// extracted by mini-css-extract-plugin
module.exports = {"root":"PercentChart_root__1av4p"};